import { useState, useEffect } from 'react';
import { HostBackend } from '../../../../Routes/HostBackend.js';
/* document */
import { Select } from '../../Form/Inputs/Select.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Text } from '../../Form/Inputs/Text.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Characters = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/characters`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Select name="id_park" choosers={choosers.parks} value={el ? el.id_park : ''} />
            <Select name="id_origin" choosers={choosers.origin} value={el ? el.id_origin : ''} />
            <Select name="id_category" choosers={choosers.category} value={el ? el.id_category : ''} />
            <Select name="id_family" choosers={choosers.family} value={el ? el.id_family : ''} />
            <Text name="name" value={el ? el.name : ''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Text name="route" value={el ? el.route : ''} class={'active-check'} />
            <Text name="author" value={el ? el.author : ''} />
            <Date name="created" value={el ? el.created : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Select name="id_public" choosers={choosers.public} value={el ? el.id_public : ''} />
            <Select name="id_photopass" choosers={choosers.photopass} value={el ? el.id_photopass : ''} />
            <Select name="id_pmr" choosers={choosers.pmr} value={el ? el.id_pmr : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}